














































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Invoice } from '../models/invoice';
import { errorMessage } from '../store/types';

@Component({
  name: 'InvoiceDetail',
})
export default class InvoiceDetail extends Vue {
  @Action('org/invoices/fetchOne') fetchOneInvoice!: (
    invoiceId: number
  ) => Promise<Invoice>;
  @Getter('org/invoices/getInvoice') invoice!: () => Invoice;

  loading = true;
  errorMessage = '';

  tableHeaders = [
    { text: 'T3', value: 't3', sortable: false },
    { text: 'NDC', value: 'ndc' },
    { text: 'Product', value: 'product' },
    { text: 'Size', value: 'size' },
    { text: 'Qty', value: 'quantity', align: 'right' },
    { text: 'Price', value: 'price', align: 'right' },
    { text: 'Total', value: 'total', align: 'right' },
  ];

  created() {
    if (this.$route.params.invoiceId) {
      const invoiceId = parseInt(this.$route.params.invoiceId);
      this.loading = true;
      this.fetchOneInvoice(invoiceId)
        .then(() => {
          this.loading = false;
        })
        .catch((error: errorMessage) => {
          this.loading = false;
          this.errorMessage = error.message;
        });
    }
  }
}
